import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative-position width-auto self-start base-margin-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SIcon = _resolveComponent("SIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SIcon, {
      size: _ctx.size,
      name: _ctx.iconName
    }, null, 8, ["size", "name"]),
    (_ctx.signed)
      ? (_openBlock(), _createBlock(_component_SIcon, {
          key: 0,
          class: "sign-icon",
          size: _ctx.signedIconSize,
          name: "custom:files/signed"
        }, null, 8, ["size"]))
      : (_ctx.needSign)
        ? (_openBlock(), _createBlock(_component_SIcon, {
            key: 1,
            class: "need-sign-icon",
            size: _ctx.signedIconSize,
            name: "custom:files/need-sign",
            title: "Файл должен быть подписан ЭЦП"
          }, null, 8, ["size"]))
        : _createCommentVNode("", true)
  ]))
}